import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Spinner } from "react-bootstrap";
import { Box, Button, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import Modal from "../../../../Components/Modal/Modal";
import { createAssetCategory } from "../../../../Redux/Actions/assetActions";
import { errorNotify, successNotify } from "../../../../Utils/toast";

const useStyle = makeStyles((theme) => ({
  cancelBtn: {
    background: "red !important",
    color: "white !important",
    padding: "8px 20px !important",
    borderRadius: "25px !important",
    boxShadow: "none !important",
  },
  createLeaveBtn: {
    background: "linear-gradient(to bottom, #0097d9, #00b1ff) !important",
    color: "white !important",
    padding: "8px 20px !important",
    borderRadius: "25px !important",
    boxShadow: "none !important",
  },
}));

const AddCategoryModal = ({ open, onClose, onCategoryCreated }) => {
  const classes = useStyle();
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    setCategoryName("");
    setLoading(false);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoryName.trim()) return;
    setLoading(true);
    try {
      dispatch(createAssetCategory({ name: categoryName.trim() }));
      // Call parent callback to refresh categories
      if (onCategoryCreated) onCategoryCreated();
      setLoading(false);
      successNotify("Category added successfully!");
      handleClose();
    } catch (err) {
      setLoading(false);
      errorNotify(err?.message || "Failed to add category");
    }
  };

  return (
    <Modal open={open} setOpen={onClose} title="Add Asset Category" size="400">
      <Form onSubmit={handleSubmit}>
        <Box sx={{ maxHeight: 300, overflowY: "auto", pr: 1 }}>
          <TextField
            label="Category Name"
            fullWidth
            sx={{ mb: 2 }}
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            required
          />
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}
        >
          <Button
            type="button"
            onClick={handleClose}
            variant="contained"
            className={classes.cancelBtn}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            className={classes.createLeaveBtn}
            disabled={loading}
          >
            {loading ? <Spinner size="sm" animation="border" /> : "Add"}
          </Button>
        </Box>
      </Form>
    </Modal>
  );
};

AddCategoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCategoryCreated: PropTypes.func,
};

export default AddCategoryModal;
